module.exports = __webpack_public_path__ + "img/s-banner.199dd686.png";